import {useNavigate} from "react-router-dom";
import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Button from "@material-ui/core/Button";


export const GoBackButton = ({
    goBack
}: any) => {
    const navigate = useNavigate();

    return (
               <Button onClick={() => {goBack ? goBack() : navigate(-1)}} color="inherit">
                        <ArrowBackIosIcon />
        </Button>
    );
}
